import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

function isProfileTabActive(pathname) {
  if (pathname.includes("change-password")) return false;
  return (
    pathname === "/portal/profile" ||
    pathname === "/portal/profile/" ||
    pathname === "/portal/profile/edit" ||
    pathname === "/portal/profile/edit/"
  );
}

function isChangePasswordTabActive(pathname) {
  return pathname.includes("change-password");
}

function CustomerProfileLayout() {
  const { pathname } = useLocation();
  const profileActive = isProfileTabActive(pathname);
  const passwordActive = isChangePasswordTabActive(pathname);

  return (
    <div className="cportal-page">
      <nav className="cportal-profile-nav" aria-label="Profile sections">
        <Link
          to="/portal/profile"
          className={`cportal-profile-nav-link${profileActive ? " active" : ""}`}
          aria-current={profileActive ? "page" : undefined}
        >
          My Profile
        </Link>
        <Link
          to="/portal/profile/change-password"
          className={`cportal-profile-nav-link${passwordActive ? " active" : ""}`}
          aria-current={passwordActive ? "page" : undefined}
        >
          Change Password
        </Link>
      </nav>

      <Outlet />
    </div>
  );
}

export default CustomerProfileLayout;
